import { useState } from 'react';
import './styles/index.css';

import HeroSection from './HeroSection';  
import SocialMediaPost from './SocialMediaPost';

export default function ProductLaunch() {
  const [dark, setDark] = useState(false);

  function toggleTheme() {
    setDark((d) => !d);
  }

  return (
    <div className={dark ? 'dark' : ''}>
      <div
        className="relative bg-gray-50 dark:bg-[#070A08] transition-colors duration-300
                      overflow-x-hidden"
      >
        {/* Grid background */}
        <div
          className={`fixed inset-0 pointer-events-none z-0
            ${dark ? 'bg-grid-dark' : 'bg-grid-light'}`}
        />

        {/* Theme toggle — fixed top-right */}
        <button
          onClick={toggleTheme}
          aria-label="Toggle theme"
          className="fixed bottom-6 right-6 z-[999] w-12 h-12
             bg-white dark:bg-[#121212]
             border border-[#00C76A] dark:border-white/20
             rounded-full shadow-xl
             hover:shadow-2xl hover:scale-105
             flex items-center justify-center
             transition-all duration-200"
        >
          {dark ? (
            // Sun icon — click to go Light
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 text-yellow-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 3v1m0 16v1m8.66-9H21M3 12H2m15.364-6.364l-.707.707
               M6.343 17.657l-.707.707m12.728 0l-.707-.707M6.343 6.343l-.707-.707
               M12 8a4 4 0 100 8 4 4 0 000-8z"
              />
            </svg>
          ) : (
            // Moon icon — click to go Dark
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 text-[#00C76A]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"
              />
            </svg>
          )}
        </button>

        {/* Page sections */}
        <div className="relative z-10">
          <HeroSection />
          <SocialMediaPost />
          {/* <HintCards />
          <SpecSheet />
          <CityRollout />
          <SocialShare /> */}
        </div>
      </div>
    </div>
  );
}
